import { useSampleRequestPageLink } from "../../../common";

export function useQualityReportData(rowData) {
  // Fetching sample request page link using custom hook based on rowData
  const sampleRequestPageLink = useSampleRequestPageLink(
    rowData.sampleRequestID
  );

  // Destructuring rowData to extract specific details for display
  let {
    id,
    qualityReportsID,
    sampleRequestID,
    sampleItemID,
    HODApproval,
    execChefApproval,
    userApproval,
    itemERPCode,
    itemDescription,
    specification,
    productClass,
    requesterEmail,
    executiveChefEmail,
    HODDepartment,
    primaryProductImages,
    secondaryProductImages,
    productImages,
    requestDate,
    email,
    name,
    receiptDate,
    deliveredDate,
    erpId,
    erpName,
    receivedItemDescription,
    receivedProductClass,
    newItemERPCode,
    brand,
    countryOfOrigin,
    packaging,
    productionDate,
    expiryDate,
    preferredUnitOfMeasure,
    quantityForSample,
    dateSupplierAdded,
    ...rowRest
  } = rowData;

  // Grouping data into sections for display
  let ids = {
    requestDate,
    qualityReportsID,
    sampleItemID,
  };
  let itemDetails = {
    requestedItemERPCode: itemERPCode,
    itemDescription,
    specification,
    productClass,
    preferredUnitOfMeasure,
    quantityForSample,
    // requesterEmail,
    // executiveChefEmail,
    // HODDepartment,
  };

  let supplierDetails = {
    supplierName: name,
    supplierEmail: email,
    dateSupplierAdded,
  };
  let sampleDetails = {
    newItemERPCode: newItemERPCode ? newItemERPCode : "N/A",
    receivedItemDescription: receivedItemDescription
      ? receivedItemDescription
      : "N/A",
    receivedProductClass: receivedProductClass ? receivedProductClass : "N/A",
    brand,
    countryOfOrigin,
    packaging,
    receiptDate,
    productionDate,
    expiryDate,
    ...rowRest,
  };
  let receiverDetails = {
    deliveredDate,
    receiverErpId: erpId,
    receiverErpName: erpName,
  };

  let dataGroups = [
    { title: "Item Details", data: itemDetails },
    { title: "Supplier Details", data: supplierDetails },
    { title: "Sample Details", data: sampleDetails },
    { title: "Receiver Details", data: receiverDetails },
    { title: "User Approval", data: userApproval },
    { title: "Executive Chef Approval", data: execChefApproval },
    { title: "HOD Approval", data: HODApproval },
  ];

  // Grouping received product images into primary and secondary categories

  let receivedProductImages = [
    {
      title: "Primary Product Image(s)",
      images:
        primaryProductImages &&
        primaryProductImages !== "pending" &&
        primaryProductImages,
    },
    {
      title: "Secondary Product Image(s)",
      images:
        secondaryProductImages &&
        secondaryProductImages !== "pending" &&
        secondaryProductImages,
    },
  ];

  return {
    sampleRequestPageLink,
    itemERPCode,
    receivedItemDescription,
    requesterEmail,
    executiveChefEmail,
    HODDepartment,
    ids,
    dataGroups,
    receivedProductImages,
  };
}
